export const APP_VERSION = 'v11.01';
